import { Col, Form, Row } from 'react-bootstrap'
import { emptyDate, isEmptyDate } from '../../../utils/emptyDate'
import React, { useCallback, useEffect, useState } from 'react'
import CustomDatePicker from '../../Forms/CustomDatePicker'
import { getIsoDate } from '../../../utils/getIsoDate'
import { useTranslation } from 'react-i18next'
import { StyledValidationMessage } from '../../Employees/Form/formHelper'
import MandatoryField from '../../MandatoryField/MandatoryField'


const SortedOutRFIDs = ({ formData, setFormData, formErrors }) => {
    const { t } = useTranslation()
    const [dateFrom, setDateFrom] = useState(null)
    const [dateTo, setDateTo] = useState(null)

    useEffect(() => {
        setFormData(prev => {
            if (dateFrom) {
                return { ...prev, startDate: getIsoDate(dateFrom, false) }
            }
            delete prev.startDate
            return prev
        })
    }, [setFormData, dateFrom])
    useEffect(() => {
        setFormData(prev => {
            if (dateFrom) {
                let isoDate = getIsoDate(dateTo, true)
                return { ...prev, endDate: isEmptyDate(isoDate) ? emptyDate : isoDate }
            }
            delete prev.endDate
            return prev
        })
    }, [setFormData, dateTo, dateFrom])
    const handleChangeDate = useCallback(setDate => date => {
        setDate(date)
    }, [])

    return (
        <div>
            <>
                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>{`${t('from')}${'*'}`}</Form.Label>
                            <CustomDatePicker
                                dateFormat="dd.MM.yyyy"
                                placeholderText={t('date')}
                                onChange={handleChangeDate(setDateFrom)}
                                showYearDropdown
                                selected={dateFrom}
                                isInvalid={formErrors && formErrors.startDate}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>{`${t('to')}${'*'}`}</Form.Label>
                            <CustomDatePicker
                                dateFormat="dd.MM.yyyy"
                                placeholderText={t('date')}
                                onChange={handleChangeDate(setDateTo)}
                                showYearDropdown
                                selected={dateTo}
                                isInvalid={formErrors && formErrors.endDate}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                {formErrors && formErrors.startDate && <StyledValidationMessage>{formErrors.startDate}</StyledValidationMessage>}
                {formErrors && formErrors.endDate && <StyledValidationMessage>{formErrors.endDate}</StyledValidationMessage>}
            </>
            <Form.Group className="mb-3">
                <Form.Label>{t(`reportConfig:emailAddress`)}</Form.Label>
                <Form.Control
                    name="emailAddress"
                    onChange={e => setFormData(prev => ({
                        ...prev,
                        emailAddress: e.target.value
                    }))}
                    value={formData.emailAddress || ''}
                    isInvalid={formErrors && formErrors.emailAddress}
                    autoComplete="email" />
                <Form.Control.Feedback type="invalid">
                    {formErrors && formErrors.emailAddress}
                </Form.Control.Feedback>
            </Form.Group>
            <MandatoryField />
        </div>
    )
}
export default SortedOutRFIDs